<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-submenu index="1" v-if="permissionCodes.indexOf('') !== -1 || permissionCodes.indexOf('') !== -1">
        <template slot="title">
          <i class="el-icon-damai-wuyefeiyongchuzhang"></i>
          <span>门锁管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1" @click="toNewRouter('lock-concentrator-manage')" v-if="permissionCodes.indexOf('') !== -1">集中器管理</el-menu-item>
          <el-menu-item index="1-2" @click="toNewRouter('lock-gate-manage')" v-if="permissionCodes.indexOf('') !== -1">门锁管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="2" v-if="permissionCodes.indexOf('') !== -1 || permissionCodes.indexOf('') !== -1">
        <template slot="title">
          <i class="el-icon-damai-wuyefeiyongchuzhang"></i>
          <span>授权管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="2-1" @click="toNewRouter('lock-authorization-manage')" v-if="permissionCodes.indexOf('') !== -1">权限管理</el-menu-item>
          <el-menu-item index="2-2" @click="toNewRouter('lock-authorization-record')" v-if="permissionCodes.indexOf('') !== -1">授权记录</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="3" @click="toNewRouter('lock-identification-record')" v-if="permissionCodes.indexOf('') !== -1">
        <i class="el-icon-damai-wuyefeiyongchuzhang"></i>
        <span slot="title">识别记录</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('lock-log')" v-if="permissionCodes.indexOf('') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from '../../utils/nav'
import {bus} from '../../utils/bus'

const indexOfRouterNameEntities = Object.entries({
  '1-1': ['lock-concentrator-manage','lock-concentrator-add','lock-concentrator-modify'],
  '1-2': ['lock-gate-manage','lock-gate-add','lock-gate-modify'],
  '2-1': ['lock-authorization-manage','lock-authorization-add'],
  '2-2': ['lock-authorization-record'],
  '3': ['lock-identification-record'],
  '4': ['lock-log'],
})

export default {
  name: 'lock-nav',
  mixins: [navMixin],
  computed:{
    defaultActiveMenuIndex () {
      const {name: routeName} = this.$route
      const entity = indexOfRouterNameEntities
        .find(([, routeNames]) => {
          if (routeNames instanceof Array) {
            return routeNames.indexOf(routeName) >= 0
          } else {
            return routeNames === routeName
          }
        })
      return entity && entity[0]
    }
  },
  data () {
    return {
      isCollapse: false,
      permissionCodes: '',
      indexOfRouterNameEntities
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
  },
  mounted() {
    bus.vue.$on('changeIsCollapse', data => {
      this.isCollapse = data
    })
  },
  methods: {
    toNewRouter (name) {
      this.$router.push({
        name: name
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/GateLock/LockNav.vue